module.exports = __webpack_public_path__ + "uy.svg?4bb9aa45c6f84caeb86e9ab430044489";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/uy.svg
// module id = 1216
// module chunks = 27